import { loadAsync } from "../../loadAsync";

export default loadAsync(() => import('./SoftResultsContent'));